export default class ArtworkCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-artwork-card', ArtworkCard);
